//react...
import React from "react";

//components...
import Slider from "../../components/Slider/Slider";

//styles...
import "./HomePage.styles.css";

const HomePage = () => {
  return (
    <div>
      <Slider />
      {/* News... */}
      {/* <Container fluid>
        <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
          News
        </h2>
        <Link to="/news" className="link navLink product-link mt-5">
          more...
        </Link>
      </Container>
      <Container className='mx-auto'>
        <NewsItem />
      </Container> */}

      {/* Products */}
      {/* <Container fluid>
        <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
          Products
        </h2>
        <Link to="/products" className="link navLink product-link mt-5">
          more...
        </Link>
      </Container>
      <Container className="mx-auto">
        <Row xs={1} md={2} lg={4} className="g-4 p-2 cardRow">
          <Col>
            <CardItem />
          </Col>
          <Col>
            <CardItem />
          </Col>
          <Col>
            <CardItem />
          </Col>
          <Col>
            <CardItem />
          </Col>
        </Row>
      </Container> */}

      {/* Brands */}
      {/* <Container fluid>
        <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
          Brands
        </h2>
      </Container>
      <BrandList /> */}
    </div>
  );
};

export default HomePage;
